// import React from "react";
// import { Route, Routes } from "react-router-dom";
// import Dashboard from "../pages/common/Dashboard";
// import InvitationForm from "../pages/Admin/InvitationForm";
// import InvitationList from "../pages/Admin/InvitationList";
// import MerchantList from "../pages/Admin/MerchantList";
// import AddAssets from "../pages/Admin/AddAssets";
// import PromotionList from "../pages/Admin/PromotionList";
// import ReferralList from "../pages/Admin/ReferralList";
// import FundraiserList from "../pages/Admin/FundraiserList";
// import Inquiries from "../pages/Admin/Inquiries";
// import FeaturedForm from "../pages/common/FeaturedForm";
// import NewOffer from "../pages/common/NewOffer";
// import OfferList from "../pages/common/OfferList";

// const AdminRoutes = () => {
//   return (
//     <>
//       <Routes>
//         <Route
//           path="/dashboard"
//           element={<FeaturedForm element={<Dashboard />} />}
//         />
//         <Route
//           path="/invitation-form"
//           element={<FeaturedForm element={<InvitationForm />} />}
//         />
//         <Route
//           path="/offer-form"
//           element={<FeaturedForm element={<NewOffer merchant={false} />} />}
//         />
//         <Route
//           path="/offer-list"
//           element={<FeaturedForm element={<OfferList />} />}
//         />
//         <Route
//           path="/invitation-list"
//           element={<FeaturedForm element={<InvitationList />} />}
//         />
//         <Route
//           path="/merchant-list"
//           element={<FeaturedForm element={<MerchantList />} />}
//         />
//         <Route
//           path="/add-assets"
//           element={<FeaturedForm element={<AddAssets />} />}
//         />
//         <Route
//           path="/promotions-list"
//           element={<FeaturedForm element={<PromotionList />} />}
//         />
//         <Route
//           path="/referral-list"
//           element={<FeaturedForm element={<ReferralList />} />}
//         />
//         <Route
//           path="/fundraiser-list"
//           element={<FeaturedForm element={<FundraiserList />} />}
//         />
//         <Route
//           path="/merchant-inquiries"
//           element={<FeaturedForm element={<Inquiries />} />}
//         />
//         <Route
//           path="/fundraiser-inquiries"
//           element={<FeaturedForm element={<Inquiries />} />}
//         />
//       </Routes>
//     </>
//   );
// };

// export default AdminRoutes;

import React, { useEffect, useState } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import Dashboard from "../pages/common/Dashboard";
import InvitationForm from "../pages/Admin/InvitationForm";
import InvitationList from "../pages/Admin/InvitationList";
import MerchantList from "../pages/Admin/MerchantList";
import InProcessMerchantList from "../pages/Admin/InProcessMerchantList";
import AddAssets from "../pages/Admin/AddAssets";
import PromotionList from "../pages/Admin/PromotionList";
import ReferralList from "../pages/Admin/ReferralList";
import FundraiserList from "../pages/Admin/FundraiserList";
import Inquiries from "../pages/Admin/Inquiries";
import FeaturedForm from "../pages/common/FeaturedForm";
import NewOffer from "../pages/common/NewOffer";
import OfferList from "../pages/common/OfferList";
import PrivateRoute from "./PrivateRoute";
import UserList from "../pages/Admin/UserList";
import TotalIncome from "../pages/Admin/TotalIncome";
import EditProfileForm from "../pages/Admin/EditProfileForm";
import HomepageLayout from "../pages/Admin/HomepageLayout";

const AdminRoutes = () => {
  const token = useSelector((state) => state?.authReducer?.tokenData?.token);
  const role = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role
  );

  const [isAuthenticated, setIsAuthenticated] = useState(!!token);
  const normalizedRole = typeof role === "string" ? role.toLowerCase() : role;
  const isRoleMatching = isAuthenticated && normalizedRole === "admin";

  const getRedirectPath = () => {
    switch (normalizedRole) {
      case "admin":
        return "/admin/dashboard";
      case "merchant":
        return "/merchant/dashboard";
      case "fundraiser":
        return "/fundraiser/dashboard";
      case "user":
      case "member":
        return "/";
      default:
        return "/";
    }
  };

  useEffect(() => {
    setIsAuthenticated(!!token);
  }, [token]);

  return (
    <Routes>
      <Route
        path="dashboard"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <Dashboard />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="invitation-form"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <InvitationForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="offer-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <OfferList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="invitation-list"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <InvitationList />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="merchant-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <MerchantList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="in-process-merchant-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <InProcessMerchantList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="add-assets"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <AddAssets />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="promotions-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <PromotionList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />

      <Route
        path="referral-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <ReferralList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="fundraiser-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <FundraiserList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="merchant-inquiries"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Inquiries />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="fundraiser-inquiries"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <Inquiries />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="user-list"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <UserList />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="total-income"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <TotalIncome />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route
        path="offer-form"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <NewOffer merchant={false} />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="edit-profile"
        element={
          <FeaturedForm
            element={
              isRoleMatching ? (
                <EditProfileForm />
              ) : (
                <Navigate to={getRedirectPath()} />
              )
            }
          />
        }
      />
      <Route
        path="homepage-layout"
        element={
          <PrivateRoute
            element={
              <FeaturedForm
                element={
                  isRoleMatching ? (
                    <HomepageLayout />
                  ) : (
                    <Navigate to={getRedirectPath()} />
                  )
                }
              />
            }
          />
        }
      />
      <Route path="*" element={<Navigate to={isRoleMatching ? "/admin/dashboard" : getRedirectPath()} replace />} />
    </Routes>
  );
};

export default AdminRoutes;
